export default __webpack_public_path__ + "static/media/modely5.02f1c404.jfif";